module.exports = __webpack_public_path__ + "static/media/i_phone.2738473c.webp";